import { UPDATENOTES_SUCCESS, UPDATENOTES_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const updateNotesReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATENOTES_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATENOTES_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default updateNotesReducer;
